import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>

      <p className="mb-4 text-sm text-gray-600">
        <strong>Effective Date:</strong> 2024-04-09
      </p>

      <p className="mb-4">
        Welcome to NFCScannerApp, operated by NGI. This mobile application ("App") serves as a tool for use with our main web application.
      </p>

      <h2 className="text-2xl font-semibold mb-3 mt-5">Purpose of the App</h2>
      <p className="mb-4">
        The sole function of this App is to allow users to scan Near Field Communication (NFC) tags using their mobile device and transmit the data obtained from the scan directly to NGI's designated server. This data is then processed within our main web application, according to its own terms and privacy policy.
      </p>

      <h2 className="text-2xl font-semibold mb-3 mt-5">Information We Collect and Transmit</h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li className="mb-2">
          <strong>NFC Data:</strong> When you initiate an NFC scan using the App, the data contained on the NFC tag is read by your device and immediately transmitted securely to our server.
        </li>
        <li className="mb-2">
          <strong>No Other Personal Data:</strong> This App does not independently collect, store, or process any other personal information from you, such as your name, email address, location, or device identifiers, beyond what is strictly necessary for the secure transmission of the scanned NFC data.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-3 mt-5">How We Use Information</h2>
      <p className="mb-4">
        The NFC data collected and transmitted via this App is used solely for the purpose of facilitating functionality within the associated NGI web application. The App itself does not use the data for any other purpose.
      </p>

      <h2 className="text-2xl font-semibold mb-3 mt-5">Information Sharing</h2>
      <p className="mb-4">
        The NFC data scanned by this App is transmitted <strong>only</strong> to NGI's designated server. We do not share this data with any other third parties via this mobile App. The handling of the data <em>after</em> it reaches our server is governed by the privacy policy of the main NGI web application.
      </p>

      <h2 className="text-2xl font-semibold mb-3 mt-5">Data Storage</h2>
      <p className="mb-4">
        This mobile App does not store the NFC data on your device after it has been successfully transmitted to our server.
      </p>

      <h2 className="text-2xl font-semibold mb-3 mt-5">Security</h2>
      <p className="mb-4">
        We implement reasonable technical measures to ensure the secure transmission of the NFC data from the App to our server (e.g., using HTTPS).
      </p>

      <h2 className="text-2xl font-semibold mb-3 mt-5">Changes to This Privacy Policy</h2>
      <p className="mb-4">
        We may update this Privacy Policy if the App's functionality changes. We will indicate any updates by changing the Effective Date above.
      </p>

      <h2 className="text-2xl font-semibold mb-3 mt-5">Contact Us</h2>
      <p className="mb-4">
        If you have any questions about this specific mobile App's privacy practices, please contact us at: <a href="mailto:gevernus@gmail.com" className="text-blue-600 hover:underline">gevernus@gmail.com</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy; 